import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Window from '../../../common/Window'
import Loading from '../../../common/component/Loading'
import Config from '../../../Config'

class InformationEdit extends Component {
  constructor (props) {
    super(props)
    const initialState = this.getInitialState()
    this.state = initialState
    this.apiUrl = Config.adminApiUrl.systemSettings
    this.userRole = 'admin'
  }
  getInitialState () {
    const dt = new Date()
    dt.setMinutes(dt.getMinutes() + 15)
    return {
      isLoaded: false,
      isNew: true,
      id: '',
      year: dt.getFullYear(),
      month: dt.getMonth() + 1,
      day: dt.getDate(),
      hour: dt.getHours(),
      minutes: (Math.floor(dt.getMinutes() / 15) * 15),
      body: '',
      willNotify: false
    }
  }
  componentWillMount () {
    const {params} = this.props.match
    const id = params.id
    if (id) {
      this.loadInformation(id)
    } else {
      const initialState = this.getInitialState()
      this.setState(initialState)
      this.setState({
        isLoaded: true
      })
    }
  }
  loadInformation (id) {
    const onSuccess = (res) => {
      const {params} = this.props.match
      const id = params.id
      const info = res.body.data.systemSettingValue.filter((e) => e.id === id)[0]
      this.setState({
        isLoaded: true,
        isNew: false,
        id: info.id,
        year: info.year,
        month: info.month,
        day: info.day,
        hour: info.hour,
        minutes: info.minutes,
        body: info.body,
        willNotify: info.willNotify
      })
    }
    const params = {
      command: 'get',
      systemSettingName: 'InformationSetting'
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  saveInformation () {
    const {params} = this.props.match
    const id = params.id
    const info = this.state
    if (info.year < 1000) {
      Window.alert('西暦を4桁で入力してください')
      return false
    }
    const originalDate = info.year + '/' + info.month + '/' + info.day
    const jsDate = new Date(originalDate)
    if (originalDate !== (jsDate.getFullYear() + '/' + (jsDate.getMonth() + 1) + '/' + jsDate.getDate())) {
      Window.alert('存在しない日付です')
      return false
    }
    if (info.body.trim() === '') {
      Window.alert('お知らせ本文は必須です')
      return false
    }
    let updateOrInsert
    if (id) { // 更新
      updateOrInsert = (oldSystemSettingValue) => {
        const systemSettingValue = []
        oldSystemSettingValue.forEach((e) => {
          const result = {}
          if (e.id === id) {
            result.id = info.id
            result.year = parseInt(info.year, 10)
            result.month = parseInt(info.month, 10)
            result.day = parseInt(info.day, 10)
            result.hour = parseInt(info.hour, 10)
            result.minutes = parseInt(info.minutes, 10)
            result.body = info.body
            result.willNotify = info.willNotify
          } else {
            result.id = e.id
            result.year = e.year
            result.month = e.month
            result.day = e.day
            result.hour = e.hour
            result.minutes = e.minutes
            result.body = e.body
            result.willNotify = e.willNotify
          }
          systemSettingValue.push(result)
        })
        return systemSettingValue
      }
    } else { // 新規登録
      updateOrInsert = (oldSystemSettingValue) => {
        const systemSettingValue = oldSystemSettingValue.slice()
        const result = {
          id: this.uuid(),
          year: parseInt(info.year, 10),
          month: parseInt(info.month, 10),
          day: parseInt(info.day, 10),
          hour: parseInt(info.hour, 10),
          minutes: parseInt(info.minutes, 10),
          body: info.body,
          willNotify: info.willNotify
        }
        systemSettingValue.push(result)
        return systemSettingValue
      }
    }
    const onSuccessToGet = (res) => {
      const systemSettingValue = updateOrInsert(res.body.data.systemSettingValue)
      const sorter = (a, b) => {
        const dateA = a.year * 100000000 + a.month * 1000000 + a.day * 10000 + a.hour * 100 + a.minutes
        const dateB = b.year * 100000000 + b.month * 1000000 + b.day * 10000 + b.hour * 100 + b.minutes
        if (dateA < dateB) return 1
        if (dateA > dateB) return -1
        return 0
      }
      const paramsToSet = {
        command: 'set',
        systemSettingName: 'InformationSetting',
        systemSettingValue: systemSettingValue.sort(sorter)
      }
      const onSuccessToPost = (res) => {
        Window.alert('保存しました', () => {
          if (this.state.isNew) {
            this.props.history.push('/admin/information')
          } else {
            this.props.history.push('/admin/information/detail/' + id)
          }
          Window.closeDialog()
        })
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
    }
    const paramsToGet = {
      command: 'get',
      systemSettingName: 'InformationSetting'
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToGet, onSuccessToGet)
  }
  onPageMenuClicked (name) {
    const id = this.state.id
    switch (name) {
      case 'back':
        if (this.state.isNew) {
          this.props.history.push('/admin/information')
        } else {
          this.props.history.push('/admin/information/detail/' + id)
        }
        break
      default:
        break
    }
  }
  uuid () {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid
  }
  renderInformationDetail (state) {
    const info = state
    const changed = (name, e) => this.setState({[name]: e.target.value})
    const toggleCheckBox = (e) => this.setState({ willNotify: !this.state.willNotify })
    const title = state.isNew ? '新規登録' : '変更'
    return (
      <fieldset>
        <legend>事務局からのお知らせ - {title}</legend>
        <br />
        <div className='control-group row'>
          <label className='span3'>公開日 <span className='required'>*</span></label>
          <div className='span13'>
            西暦 <input className='span2' type='text' value={info.year} onChange={e => changed('year', e)} />
            <span className='kw-info-unit'>年</span>
            <select className='span2' value={info.month} onChange={e => changed('month', e)}>
              <option value='1'>01</option>
              <option value='2'>02</option>
              <option value='3'>03</option>
              <option value='4'>04</option>
              <option value='5'>05</option>
              <option value='6'>06</option>
              <option value='7'>07</option>
              <option value='8'>08</option>
              <option value='9'>09</option>
              <option value='10'>10</option>
              <option value='11'>11</option>
              <option value='12'>12</option>
            </select>
            <span className='kw-info-unit'>月</span>
            <select className='span2' value={info.day} onChange={e => changed('day', e)}>
              <option value='1'>01</option>
              <option value='2'>02</option>
              <option value='3'>03</option>
              <option value='4'>04</option>
              <option value='5'>05</option>
              <option value='6'>06</option>
              <option value='7'>07</option>
              <option value='8'>08</option>
              <option value='9'>09</option>
              <option value='10'>10</option>
              <option value='11'>11</option>
              <option value='12'>12</option>
              <option value='13'>13</option>
              <option value='14'>14</option>
              <option value='15'>15</option>
              <option value='16'>16</option>
              <option value='17'>17</option>
              <option value='18'>18</option>
              <option value='19'>19</option>
              <option value='20'>20</option>
              <option value='21'>21</option>
              <option value='22'>22</option>
              <option value='23'>23</option>
              <option value='24'>24</option>
              <option value='25'>25</option>
              <option value='26'>26</option>
              <option value='27'>27</option>
              <option value='28'>28</option>
              <option value='29'>29</option>
              <option value='30'>30</option>
              <option value='31'>31</option>
            </select>
            <span className='kw-info-unit'>日</span>
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>公開時刻 <span className='required'>*</span></label>
          <div className='span13 row'>
            <select className='span2' value={info.hour} onChange={e => changed('hour', e)}>
              <option value='0'>00</option>
              <option value='1'>01</option>
              <option value='2'>02</option>
              <option value='3'>03</option>
              <option value='4'>04</option>
              <option value='5'>05</option>
              <option value='6'>06</option>
              <option value='7'>07</option>
              <option value='8'>08</option>
              <option value='9'>09</option>
              <option value='10'>10</option>
              <option value='11'>11</option>
              <option value='12'>12</option>
              <option value='13'>13</option>
              <option value='14'>14</option>
              <option value='15'>15</option>
              <option value='16'>16</option>
              <option value='17'>17</option>
              <option value='18'>18</option>
              <option value='19'>19</option>
              <option value='20'>20</option>
              <option value='21'>21</option>
              <option value='22'>22</option>
              <option value='23'>23</option>
            </select>
            <span className='kw-info-unit'>時</span>
            <select className='span2' value={info.minutes} onChange={e => changed('minutes', e)}>
              <option value='0'>00</option>
              <option value='15'>15</option>
              <option value='30'>30</option>
              <option value='45'>45</option>
            </select>
            <span className='kw-info-unit'>分</span>
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>お知らせ <span className='required'>*</span></label>
          <div className='span10'>
            <textarea name='informationBody' className='span10' value={info.body} onChange={e => changed('body', e)} />
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>メール通知 <span className='required'>*</span></label>
          <div className='span10'>
            <label htmlFor='informationReSend' style={{cursor: 'pointer'}}><input type='checkbox' id='informationReSend' name='informationReSend' checked={info.willNotify} onClick={(e) => toggleCheckBox(e)} />予定時刻がきたらメールを送信する{info.willNotify}</label>
            <p style={{color: 'red'}}>15分ごとにお知らせをチェックし、こちらのチェックボックスにチェックが付いている場合はメールを送信します。<br />
            送信後、自動でチェックが外れます。お知らせを送信したくない場合はチェックせずに保存してください。</p>
          </div>
        </div>
      </fieldset>
    )
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    const id = this.state.id
    switch (name) {
      case 'save':
        this.saveInformation()
        break
      case 'cancel':
        if (this.state.isNew) {
          this.props.history.push('/admin/information')
        } else {
          this.props.history.push('/admin/information/detail/' + id)
        }
        break
      default:
        break
    }
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const informationDetail = this.renderInformationDetail(this.state)
    const title = this.state.isNew ? '新規登録' : '変更'
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>事務局からのお知らせ - {title}<br /><small>こちらで事務局からのお知らせを{title}できます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <form className='form-horizontal' method='post'>
            <div className='container'>
              <div className='kw-ic-info-regist-area span16'>
                <div className='alert alert-block alert-info'>
                  <p>必要な情報を入力して最後に「保存」ボタンを押してください。「<span className='required'>*</span>」マークは必須項目です。</p>
                </div>
                {informationDetail}
                <footer className='form-actions' id='submit-actions'>
                  <button className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('save', e)} >保存</button>
                  <button className='btn btn-default' onClick={(e) => this.onFormButtonClicked('cancel', e)}>キャンセル</button>
                </footer>
              </div>
            </div>
          </form>
        </section>
      </div>
    )
  }
}

export default InformationEdit



// WEBPACK FOOTER //
// ./src/admin/pages/secure/InformationEdit.js